export function isValidIsraeliID(israeliId: string | number): boolean {
  israeliId = String(israeliId).trim();

  if (!/^\d+$/.test(israeliId) || israeliId.length < 7 || israeliId.length > 9) {
    return false;
  }

  israeliId = israeliId.padStart(9, '0');

  return (
    Array.from(israeliId, Number).reduce((sum, digit, i) => {
      const step = digit * ((i % 2) + 1);
      return sum + (step > 9 ? step - 9 : step);
    }, 0) %
      10 ===
    0
  );
}
